'use client'
const Spinner = () => {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="loader ease-linear rounded-full border-2 border-t-2 border-primary h-4 w-4"></div>
    </div>
  )
};

export default Spinner;